export default function () {
  if (document.getElementById('pay-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "pay-app" */ '../_03_organisms/ubiq-administration/main');
  }
}
